import { service } from "@/common/axios-service";
const state = {
}

const getters={
}

const actions ={
  async GetTests(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Student/GetTests?category="+form,{})
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async SaveAnswerTest(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Student/SaveAnswerTest",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
}

const mutations ={
}

export default{
    state,
    getters,
    actions,
    mutations
};